import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import React from "react";

const CascadeIcon = (props: { size: number }) => {
  return (
    <svg
      width={props.size}
      height={props.size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.49102 43H20.2607C20.7693 43 21.1815 42.5878 21.1815 42.0792C21.1815 41.5706 20.7693 41.1584 20.2607 41.1584H16.2662V19.2832H32.5784V41.1584H28.3637C27.8551 41.1584 27.4429 41.5706 27.4429 42.0792C27.4429 42.5878 27.8551 43 28.3637 43H43.3535C43.8621 43 44.2743 42.5878 44.2743 42.0792V28.0083C44.2743 27.4998 43.8621 27.0875 43.3535 27.0875H34.42V18.3623C34.42 17.8537 34.0077 17.4415 33.4992 17.4415H31.1279V14.5868C31.1279 14.0782 30.7156 13.666 30.207 13.666H25.3431V6.25628C25.3431 5.7477 24.9309 5.33545 24.4223 5.33545C23.9137 5.33545 23.5015 5.7477 23.5015 6.25628V13.666H18.6375C18.1289 13.666 17.7167 14.0782 17.7167 14.5868V17.4415H15.3453C14.8368 17.4415 14.4245 17.8537 14.4245 18.3623V27.0875H5.49102C4.98244 27.0875 4.57019 27.4998 4.57019 28.0083V42.0791C4.57019 42.5878 4.98244 43 5.49102 43ZM42.4327 28.9291V41.1583H34.42V38.2029H39.1392C39.6478 38.2029 40.0601 37.7906 40.0601 37.2821C40.0601 36.7735 39.6478 36.3612 39.1392 36.3612H34.42V33.5661H39.1392C39.6478 33.5661 40.0601 33.1538 40.0601 32.6452C40.0601 32.1367 39.6478 31.7244 39.1392 31.7244H34.42V28.9292H42.4327V28.9291ZM19.5583 15.5076H29.2862V17.4415H19.5583V15.5076ZM6.41184 28.9291H14.4245V31.7243H9.70527C9.1967 31.7243 8.78445 32.1366 8.78445 32.6451C8.78445 33.1537 9.1967 33.566 9.70527 33.566H14.4245V36.3612H9.70527C9.1967 36.3612 8.78445 36.7735 8.78445 37.2821C8.78445 37.7906 9.1967 38.2029 9.70527 38.2029H14.4245V41.1583H6.41184V28.9291Z"
        fill="white"
        fill-opacity="0.4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4245 43.0044H20.2607C20.7693 43.0044 21.1815 42.5922 21.1815 42.0836C21.1815 41.575 20.7693 41.1628 20.2607 41.1628H16.2662V19.2876H32.5784V41.1628H28.3637C27.8551 41.1628 27.4429 41.575 27.4429 42.0836C27.4429 42.5922 27.8551 43.0044 28.3637 43.0044H34.42V41.1627V38.2073V36.3656V33.5705V31.7288V28.9336V27.0919V26.5044V18.3667C34.42 17.8581 34.0077 17.4459 33.4992 17.4459H31.1279V14.5912C31.1279 14.0826 30.7156 13.6704 30.207 13.6704H25.3431V6.26067C25.3431 5.7521 24.9309 5.33984 24.4223 5.33984C23.9137 5.33984 23.5015 5.7521 23.5015 6.26067V13.6704H18.6375C18.1289 13.6704 17.7167 14.0826 17.7167 14.5912V17.4459H15.3453C14.8368 17.4459 14.4245 17.8581 14.4245 18.3667V27.0919V27.5885V43.0044ZM19.5583 15.512H29.2862V17.4459H19.5583V15.512Z"
        fill="white"
      />
      <path
        d="M19.8557 24.2923H28.9888C29.4973 24.2923 29.9096 23.8801 29.9096 23.3715C29.9096 22.8629 29.4973 22.4507 28.9888 22.4507H19.8557C19.3472 22.4507 18.9349 22.8629 18.9349 23.3715C18.9349 23.8801 19.3472 24.2923 19.8557 24.2923Z"
        fill="white"
        fill-opacity="0.4"
      />
      <path
        d="M19.8557 28.9291H28.9888C29.4973 28.9291 29.9096 28.5168 29.9096 28.0082C29.9096 27.4997 29.4973 27.0874 28.9888 27.0874H19.8557C19.3472 27.0874 18.9349 27.4997 18.9349 28.0082C18.9349 28.5168 19.3472 28.9291 19.8557 28.9291Z"
        fill="white"
        fill-opacity="0.4"
      />
      <path
        d="M19.8557 33.5663H28.9888C29.4973 33.5663 29.9096 33.154 29.9096 32.6454C29.9096 32.1369 29.4973 31.7246 28.9888 31.7246H19.8557C19.3472 31.7246 18.9349 32.1369 18.9349 32.6454C18.9349 33.154 19.3472 33.5663 19.8557 33.5663Z"
        fill="white"
        fill-opacity="0.4"
      />
      <path
        d="M19.8557 38.203H28.9888C29.4973 38.203 29.9096 37.7907 29.9096 37.2822C29.9096 36.7736 29.4973 36.3613 28.9888 36.3613H19.8557C19.3472 36.3613 18.9349 36.7736 18.9349 37.2822C18.9349 37.7907 19.3472 38.203 19.8557 38.203Z"
        fill="white"
        fill-opacity="0.4"
      />
      <path
        d="M23.5466 42.5898C23.8215 43.0095 24.4079 43.1215 24.8229 42.8449C25.24 42.5669 25.3566 41.9847 25.0779 41.5677C24.7987 41.15 24.2184 41.0366 23.8008 41.3136C23.3827 41.5909 23.2692 42.1736 23.5466 42.5898Z"
        fill="white"
      />
    </svg>
  );
};

export default CascadeIcon;
